import { Button, Input } from 'antd';
import { ComplicationTable } from '../../components/Complication/ComplicationTable';
import DefaultLayout from '../../components/Layouts/DefaultLayout';
import { useState } from 'react';
import { useDebounce } from '../../hooks/useDebounce';
import { ComplicationModal } from '../../components/Modals/CreateComplicationModal';
import { Complication } from '../../dto/Complication.dto';

function ComplicationPage() {
  const [search, setSearch] = useState<string>();
  const [selectedComplication, setSelectedComplication] =
    useState<Complication>();

  const [modalOpen, setModalOpen] = useState(false);

  const debouncedSearch = useDebounce((value: string) => {
    setSearch(value);
  }, 500);

  return (
    <>
      <DefaultLayout>
        <main className='p-3'>
          <div className='mb-3'>
            <h2 className='text-black'>Complications</h2>
          </div>
          <div className='mb-3'>
            <div className='mb-3'>
              <Button onClick={onAdd}>Add</Button>
            </div>
            <div className='w-2/5 m-auto'>
              <Input
                placeholder='Search...'
                onChange={(event) => debouncedSearch(event.target.value)}
              />
            </div>
            <ComplicationTable search={search} onClick={onClick} />
          </div>
        </main>
      </DefaultLayout>

      <ComplicationModal
        setIsOpen={setModalOpen}
        isOpen={modalOpen}
        complication={selectedComplication}
      />
    </>
  );

  function onAdd() {
    setSelectedComplication(undefined);
    setModalOpen(true);
  }

  function onClick(data: Complication) {
    console.log("🚀 ~ onClick ~ data:", data)
    setSelectedComplication(data);
    setModalOpen(true);
  }
}

export default ComplicationPage;
